module.exports = __webpack_public_path__ + "img/pot.0318866e.svg";